import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { BaseInputFilter } from "domain/models/base-input-filter";
import { Logger } from "infra/logger/logger";
import documentRequiredRepository from "../../infra/repositories/document-required-repository copy";
import { DocumentRequiredInputFilter } from "domain/models/document-required-input-filter";

export const useDocumentRequiredByFilter = (
  filter: DocumentRequiredInputFilter
) => {
  const logger = Logger.getInstance();

  return useQuery({
    queryKey: ["document-required", filter],
    queryFn: async () => {
      try {
        const result = await documentRequiredRepository.getAll(filter);
        return result;
      } catch (error: any) {
        if (error instanceof AxiosError) {
          logger.error(
            error.response?.data.metadata.errors[0],
            error.response?.data.metadata
          );
          throw new Error(error.response?.data.metadata.errors);
        }
        throw error;
      }
    },
    retry: Number(process.env.REACT_APP_QUERY_RETRY) || 5,
    staleTime: Number(process.env.REACT_APP_QUERY_STALE_TIME_DEFAULT) || 0,
  });
};
